// placeholder for isValid, right now it's just a stub
const isValid = (): boolean => {
  return true;
};

export default isValid;
